import React, { useEffect }  from 'react';
import { connect } from 'react-redux';
import BreadCrumbs from "../ui-componets/breadcrumbs";
import { getGdpr } from "../modules/ui.ducks";
import Loader from '../ui-componets/loader';
import Back from "../ui-componets/Back";
import { useTranslation } from 'react-i18next';
import { useTokenAuth } from '../hooks/useTokenAuth';



interface IProps {
    history: any
    tokenDetails: any
    global: any
    getGdpr: any
    isMarketingDetailsFetching: boolean
    isUserFetching: boolean
    shopUser?: boolean
    dieselCardUser?: boolean
}

function Payment(props: IProps) {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Use reusable token authentication hook
  useTokenAuth('/profile/payments', props.global, props.tokenDetails, props.history);

  const { getGdpr, isMarketingDetailsFetching, isUserFetching } = props;
  
  useEffect(() => {
    getGdpr();
  }, [props.tokenDetails]);

  const sections = [
      { key: 'Home', content: t('Your Account'), className: 'parent-breadcrumbs font-styleLight', href: '/account', link: true },
      { key: 'Payment', className: 'child-breadcrumbs font-styleLight', content: t('Payment Details'), link: false },
  ]

  return (
    <div>
      {  isUserFetching || isMarketingDetailsFetching || isMarketingDetailsFetching === undefined ? 
    <div>
        <Loader/>
    </div>:
        <div className="static-donate-payment">
          <div className="sdp-binder sdp-binder-mobile-donate">
              {
                  props.shopUser && <div className="dropdown-for-activity dropdown-for-order pt-0 pl-5">
                      <Back
                      refreshToken={props.tokenDetails.refresh_token}
                      dieselCardUser={props.dieselCardUser}/>
                  </div>
              }
                <div className="sdp-head">

                    <div className="sdp-sub-head">
                          <img src="/profile/static/payment-deatils.svg" />
                          <p className="m-0 font-styleBold black-for-accounts pd-t-black-ac">{t('Payment Details')}</p>
                          <div className="breads">
                            {sections.length > 0 && !props.shopUser? <BreadCrumbs
                            sections={sections}
                            handleClick={(url: string) => props.history.push(url)}
                            backAction={() => props.history.goBack()} />
                        : null}
                        </div>

                        <div className="options-payment-text">
                            <p className="m-0 font-styleRegular black-for-ac">{t('If you require extra Epoints to complete your purchase you can buy more using the below payment options.')}</p>
                        </div>

                          <div className="payment-st-images">
                             <div className="sdp-sub-img">
                                <div className="sdp-img">
                                  <img src="/profile/static/paypal.svg" />
                                </div>  
                                <div className="sdp-img visa-img">
                                  <img src="/profile/static/visa.svg" />
                                </div>  
                                <div className="sdp-img">
                                  <img src="/profile/static/master-card.svg" />
                                </div>    
                             </div>      
                          </div>      

                    </div>
                </div>
            </div>
        </div>
      }
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  tokenDetails: state.join.tokens,
  global: state.global,
  isMarketingDetailsFetching: state.ui.isMarketingDetailsFetching,
  isUserFetching: state.ui.isUserFetching
});

export default connect(mapStateToProps, {getGdpr})(Payment);
